__turbopack_context__.v({
  "icon": "CoreSocialShareTools-module-scss-module__6k5kjq__icon",
  "label": "CoreSocialShareTools-module-scss-module__6k5kjq__label",
  "link": "CoreSocialShareTools-module-scss-module__6k5kjq__link",
  "list": "CoreSocialShareTools-module-scss-module__6k5kjq__list",
  "main": "CoreSocialShareTools-module-scss-module__6k5kjq__main",
});
